import React, { useEffect, useState } from 'react';
import { UiComponents } from "@simulanisindia/ui";
import ApplicationList from '../../../components/Management/ApplicationList';
import NewSubsModuleList from '../../../components/Management/ModuleList';
import {
    RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB,
    RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB,
} from '../../../Constant/constant';
import { useSelector } from 'react-redux';
import { toggleArrayByObject } from '../../../Utils/general';

const { FilterTab } = UiComponents;

const Section = ({
    renderList,
    allTabResources,
    hasMore,
    loading,
    search,
    setSearch,
    selectedResource,
    setSelectedResource,
    activeTab,
    loadMoreData,
    checkBoxAll,
    setCheckBoxAll,
    selectCheckBoxAllClicked,
    checkedFilterItem,
    setCheckedFilterItem
}) => {
    const moduleSlice = useSelector((state) => state.moduleFilterSlice);
    const applicationData = useSelector((state) => state.applicationSlice);
    const [showfilter, setShowFilter] = useState(false);

    const [filterCategoryOption, setFilterCategoryOption] = useState({
        [RESOURCE_APPLICATION_TAB]: [],
        [RESOURCE_MODULE_TAB]: [],
        [RESOURCE_ENVIRONMENT_TAB]: [],
        [RESOURCE_SKILL_STREAM_TAB]: [],
        [RESOURCE_SKILL_SCHOOL_TAB]: [],
    });

    const body = document.body;
    const openFilter = () => {
        setShowFilter(!showfilter);
        if (!showfilter) {
            body.classList.add("filter-active");
        } else {
            body.classList.remove("filter-active");
        }
    };

    useEffect(() => {
        let resourceFilterOption = moduleSlice?.allModuleCategory?.children?.map((category) => ({
            name: category.name,
            tags: category.tags.map((tag) => ({
                name: tag.name,
                key: tag.id,
                value: tag.id,
                id: tag.id,
                type: (category.name).replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase()
            })),
        }));

        let environmentFilterOption = applicationData?.environmentTypes?.children?.map((category) => ({
            name: category.name,
            tags: category.tags.map((tag) => ({
                name: tag.name,
                key: tag.id,
                value: tag.id,
                id: tag.id,
                type: (category.name).replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase()
            })),
        }));

        let appCategory = applicationData?.applicationsCategory?.tags || [];
        let applicationFilterOptions = [
            {
                name: "Category",
                tags: appCategory.map((tag) => ({
                    name: tag.name,
                    key: tag.id,
                    value: tag.id,
                    id: tag.id,
                    type: "Category".replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase()
                })),
            },
        ];

        setFilterCategoryOption(() => ({
            [RESOURCE_MODULE_TAB]: resourceFilterOption,
            [RESOURCE_APPLICATION_TAB]: applicationFilterOptions,
            [RESOURCE_ENVIRONMENT_TAB]: environmentFilterOption,
            [RESOURCE_SKILL_STREAM_TAB]: [],
            [RESOURCE_SKILL_SCHOOL_TAB]: [],
        }));
    }, [applicationData, moduleSlice]);

    const handleClickSelectCheckbox = (item) => {
        setCheckedFilterItem((pre) => ({
            ...pre,
            [activeTab]: toggleArrayByObject(pre[activeTab], item)
        }))
    }

    const handleResetCheckBox = () => {
        setCheckedFilterItem((pre) => ({
            ...pre,
            [activeTab]: []
        }))
    }

    const renderContent = () => {
        switch (activeTab) {
            case RESOURCE_APPLICATION_TAB:
                return <ApplicationList selectedCheckboxes={checkedFilterItem[activeTab]} openFilter={openFilter} filterOptions={filterCategoryOption[activeTab]} hasMore={hasMore} loadMoreData={loadMoreData} search={search} setSearch={setSearch} renderList={renderList} showFilter={false} />;
            case RESOURCE_MODULE_TAB:
                return <NewSubsModuleList selectedCheckboxes={checkedFilterItem[activeTab]} openFilter={openFilter} filterOptions={filterCategoryOption[activeTab]} hasMore={hasMore} loadMoreData={loadMoreData} search={search} setSearch={setSearch} renderList={renderList} showFilter={true} placeholder="" roleId="xrModules" heading="XR Modules" description="XR Modules" />;
            case RESOURCE_ENVIRONMENT_TAB:
                return <NewSubsModuleList selectedCheckboxes={checkedFilterItem[activeTab]} openFilter={openFilter} filterOptions={filterCategoryOption[activeTab]} hasMore={hasMore} loadMoreData={loadMoreData} search={search} setSearch={setSearch} renderList={renderList} showFilter={true} placeholder="" roleId="enviroments" heading="Enviroments" description="Enviroments" />;
            case RESOURCE_SKILL_STREAM_TAB:
                return <NewSubsModuleList selectedCheckboxes={checkedFilterItem[activeTab]} openFilter={openFilter} filterOptions={filterCategoryOption[activeTab]} hasMore={hasMore} loadMoreData={loadMoreData} search={search} setSearch={setSearch} renderList={renderList} showFilter={false} placeholder="" roleId="skillStream" heading="Skill Stream" description="Skill Stream" />;
            case RESOURCE_SKILL_SCHOOL_TAB:
                return <NewSubsModuleList selectedCheckboxes={checkedFilterItem[activeTab]} openFilter={openFilter} filterOptions={filterCategoryOption[activeTab]} hasMore={hasMore} loadMoreData={loadMoreData} search={search} setSearch={setSearch} renderList={renderList} showFilter={false} placeholder="" roleId="skillschool" heading="Skill School" description="Skill School" />;
            default:
                return <></>;
        }
    };

    return (
        <>
            {renderContent()}

            <FilterTab
                showfilter={showfilter}
                selectedCheckboxes={checkedFilterItem[activeTab]}
                setSelectedCheckboxes={handleClickSelectCheckbox}
                filterOptions={filterCategoryOption[activeTab]}
                onToggleFilter={() => openFilter(null)}
                handleResetCheckBox={handleResetCheckBox}
            />
        </>
    )
}

export default Section